import React from 'react';
import {
  Area, AreaChart, CartesianGrid, LineChart, Line,
  ResponsiveContainer,
  Tooltip, XAxis, YAxis,
} from 'recharts';
import moment from 'moment';

import { CubeJsGraphBase } from './base';

const COLOR_PRIMARY = '#4C00D2';
const COLOR_SHADE = 'rgba(76, 0, 210, 0.2)';

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div className="custom-graph-tooltip">
        <p className="label">{`${label} : ${payload[0].value}`}</p>
        {/* <p className="intro">{getIntroOfPage(label)}</p> */}
        {/* <p className="desc">Anything you want can be displayed here.</p> */}
      </div>
    );
  }

  return null;
};
export default abstract class LineGraphBase extends CubeJsGraphBase {
    xAxisFormatter: ((value: string) => string) | null = null

    yAxisFormatter: ((value: string) => string) | null = null

    labelFormatter: ((value: any) => string) | null = null

    formatter: ((value: string) => string | string[]) | null = null

    queryRender(props) {
      // const data = resultSet
      //   .pivot()
      //   .map(({ xValues, yValuesArray }) => yValuesArray.map(([yValues, m]) => ({
      //     x: resultSet.axisValuesString(xValues, ', '),
      //     color: resultSet.axisValuesString(yValues, ', '),
      //     measure: m && Number.parseFloat(m),
      //   })))
      //   .reduce((a, b) => a.concat(b), []);

      // console.log(data);

      const data = props.resultSet.chartPivot();

      return (
        <ResponsiveContainer width="100%" aspect={6}>
          <LineChart
            data={data}
            margin={{
              top: 20, right: 10, left: -10, bottom: 5,
            }}
          >
            <XAxis tickMargin={10} dataKey="x" tick={{ fontSize: '14px', fill: '#a9a9a9' }} stroke="#dfdfdf" ticks={[data[0].x, data[data.length - 1].x]} interval="preserveStartEnd" tickFormatter={this.xAxisFormatter} />
            <YAxis tick={{ fontSize: '14px', fill: '#a9a9a9' }} stroke="#dfdfdf" interval="preserveStartEnd" tickFormatter={this.yAxisFormatter} />
            <CartesianGrid stroke="#dfdfdf" vertical={false} horizontal />
            {props.resultSet.seriesNames().map((series, i) => (
              <Line
                key={series.key}
                stackId="a"
                dataKey={series.key}
                name={series.title}
                // type="monotone"
                // dataKey="measure"
                stroke={COLOR_PRIMARY}
                strokeWidth={2}
                dot
              />
            ))}
            <Tooltip
              // position={{ x: 0, y: 0 }}
              contentStyle={{
                borderRadius: '4px', border: 0, fontWeight: 'medium-bold', fontFamily: '"Noto Sans JP", sans-serif', fontSize: '14px', fill: '#424446',
              }}
              labelStyle={{
                fontWeight: 'medium-bold', fontFamily: '"Noto Sans JP", sans-serif', fontSize: '14px', fill: '#424446',
              }}
              itemStyle={{
                fontWeight: 'bold', fontFamily: '"Noto Sans JP", sans-serif', fontSize: '14px', color: '#424446', stroke: '#424446', fill: '#424446',
              }}
              wrapperStyle={{ borderRadius: '4px', border: 0, boxShadow: '0 2px 3px 0 rgba(0, 0, 0, 0.1)' }}
              labelFormatter={this.labelFormatter}
              formatter={this.formatter}
            />
          </LineChart>
        </ResponsiveContainer>
      );
    }
}
